import React from 'react';
import PanettoneProductGroupDetail from 'components/Tvendo/Sale/QuotaBPartner/WinterCuotas/Panettone/ProductGroups/Detail/Detail';

export default function () {
  return <PanettoneProductGroupDetail />;
}
